export default "__VITE_ASSET__ClEvxhPb__"